import React from 'react';
import Header from "../components/Header";
import Footer from "../components/footer";

const NewsEvents = () => {

    const news = [
        {
            id: 1,
            title: "AICAD and Kenya Airways Sign Strategic MoU to Advance Digital Skills and AI",
            summary:
                "On 10th February 2026, AICAD signed a Memorandum of Understanding with Kenya Airways (KQ) to strengthen collaboration in Software Engineering, Data & Analytics, Cybersecurity, and Artificial Intelligence. The partnership will support training, internships, mentorship, and applied research initiatives aimed at building a future-ready digital workforce.",
            image: "/images/MD_and-CEO-shake-hands-and-displaying-signed-MOU.png",
            date: "February 10, 2026",
            link: "/news/kenya-airways-aicad-mou-digital-skills-innovation",
            isFeatured: true,
        },
    ];


    const events = [
        {
            id: 1,
            title: 'ICTD Conference 2024',
            image:'https://aospea.org/static/images/ictd-org.png',
            details: 'Data stewardship and use for scientific and socio-economic development.',
            location: 'Nairobi, Kenya',
            dateTime: 'December 9 - 11, 2024',
            isUpcoming: false,
            eventLink:"https://ictd.org/",
            preEvent:"https://ictd.aospea.org/ICTDBooking/images/ictd-pre-conference.png",
            mainEventPoster:"https://aosp.org/ictd-main-conference-poster-final.jpg"
        },
        {
            id: 2,
            title: 'VizAfrica Conference 2024',
            image:'https://aospea.org/VIZPHOTO.jpg',
            details: 'Explore the transformative power of ICT in addressing crucial development changes across the globe.',
            location: 'Nairobi, Kenya',
            dateTime: 'February 5 - 7, 2024',
            isUpcoming: false,
            eventLink:"https://datatin.net/vizafrica-conference-and-symposiun/"
        },

        {
            id: 5,
            title: 'VizAfrica Conference 2025',
            image:'https://aospea.org/VIZPHOTO.jpg',
            details: 'Harnessing AI and Collaborative Platforms for Secure, Scalable Data Sharing and Visualization towards SDGs.',
            location: 'Nairobi, Kenya',
            dateTime: 'December, 2025',
            isUpcoming: false,
            isFeatured:true,
            eventLink:"https://datatin.net/events/vizafrica-conference-2025"
        },
    ];

    return (
        <div className="w-full p-6 flex flex-col">
            <Header/>
            <div className="container h-auto mx-auto mt-20 py-8 px-4">
                <h1 className="text-3xl underline font-bold mb-8">News & Events</h1>

                <section className="mb-12">
                    <h2 className="text-2xl font-semibold mb-6">Latest News</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {news.length === 0 ? (
                            <p className="col-span-full text-lg font-semibold text-gray-500">
                                No news available
                            </p>
                        ) : (
                            news.map(item => (
                                <div key={item.id} className="bg-white rounded-lg shadow-xl overflow-hidden">
                                    <div className="relative">
                                        <img
                                            src={item.image}
                                            alt={item.title}
                                            className="w-full full object-cover"
                                        />
                                        {item.isFeatured && (
                                            <div
                                                className="absolute top-4 left-4 bg-white text-blue-500 py-1 px-3 rounded-full text-sm font-semibold shadow-md">
                                                Featured
                                            </div>
                                        )}
                                    </div>
                                    <div className="p-6">
                                        <h3 className="text-xl font-semibold text-gray-800 mb-2">
                                            {item.title}
                                        </h3>
                                        <p className="text-gray-700 text-base mb-4">
                                            {item.summary}
                                        </p>
                                        <div className="flex items-center text-gray-500 text-sm mb-4">
                                            <svg
                                                className="w-4 h-4"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                strokeWidth="2"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                                />
                                            </svg>
                                            <span className="ml-2">{item.date}</span>
                                        </div>
                                        <a
                                            href={item.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="inline-block py-2 px-4 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition duration-300"
                                        >
                                            Read More
                                        </a>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </section>

                {/* Upcoming Events Section */}
                <section className="mb-12">
                    <h2 className="text-2xl font-semibold mb-6">Upcoming Events</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {events.filter(event => event.isUpcoming).length === 0 ? (
                            <p className="col-span-full text-lg font-semibold text-gray-500">
                                No upcoming events
                            </p>
                        ) : (
                            events.filter(event => event.isUpcoming).map(event => (
                                <div key={event.id} className="bg-white rounded-lg shadow-xl overflow-hidden">
                                    <div className="relative">
                                        <img
                                            src={event.image} // Assuming `image` is the URL of the event's image
                                            alt={event.title}
                                            className="w-auto h-48 "
                                        />
                                        <div
                                            className="absolute top-4 left-4 bg-white text-blue-500 py-1 px-3 rounded-full text-sm font-semibold shadow-md">
                                            {event.isFeatured ? 'Featured' : 'Past Event'}
                                        </div>
                                    </div>
                                    <div className="p-6">
                                        <h3 className="text-2xl font-semibold text-gray-800 mb-2">{event.title}</h3>
                                        <p className="text-gray-700 text-base mb-1">{event.details}</p>
                                        {event.preEvent &&
                                            <p className="text-gray-700 text-base mb-1"><b>Pre-Event poster:</b> <a
                                                className="text-blue-600" href={event.preEvent}>Click Here</a></p>}
                                        {event.mainEventPoster &&
                                            <p className="text-gray-700 text-base mb-1"><b>Main-Event poster:</b> <a
                                                className="text-blue-600" href={event.mainEventPoster}>Click Here</a>
                                            </p>}
                                        <div className="flex items-center space-x-4 text-gray-500">
                                            <div className="flex items-center">
                                                <svg className="w-4 h-4 text-gray-500"
                                                     xmlns="http://www.w3.org/2000/svg"
                                                     fill="none" viewBox="0 0 24 24" strokeWidth="2"
                                                     stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round"
                                                          d="M12 8v4l3 2M12 8l-3 2M12 8l-3 2M12 8l3 2"/>
                                                </svg>
                                                <p className="ml-2 text-sm">{event.location}</p>
                                            </div>
                                            <div className="flex items-center">
                                                <svg className="w-4 h-4 text-gray-500"
                                                     xmlns="http://www.w3.org/2000/svg"
                                                     fill="none" viewBox="0 0 24 24" strokeWidth="2"
                                                     stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round"
                                                          d="M12 6v6m0 0L9 9m3 3l3-3"/>
                                                </svg>
                                                <p className="ml-2 text-sm">{event.dateTime}</p>
                                            </div>
                                        </div>
                                        <div className="mt-4 w-full">
                                            <a href={event.eventLink} target="_blank"
                                               className="w-full py-2 px-4 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition duration-300">
                                                Learn More
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </section>

                {/* Past Events Section */}
                <section>
                    <h2 className="text-3xl font-semibold text-gray-900 mb-8">Past Events</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {events.filter(event => !event.isUpcoming).map(event => (
                            <div key={event.id} className="bg-white rounded-lg shadow-xl overflow-hidden">
                                <div className="relative">
                                    <img
                                        src={event.image} // Assuming `image` is the URL of the event's image
                                        alt={event.title}
                                        className="w-auto h-48 "
                                    />
                                    <div
                                        className="absolute top-4 left-4 bg-white text-blue-500 py-1 px-3 rounded-full text-sm font-semibold shadow-md">
                                        {event.isFeatured ? 'Featured' : 'Past Event'}
                                    </div>
                                </div>
                                <div className="p-6">
                                    <h3 className="text-2xl font-semibold text-gray-800 mb-2">{event.title}</h3>
                                    <p className="text-gray-700 text-base mb-1">{event.details}</p>
                                    {event.preEvent &&
                                        <p className="text-gray-700 text-base mb-1"><b>Pre-Event poster:</b> <a
                                            className="text-blue-600" href={event.preEvent}>Click Here</a></p>}
                                    {event.mainEventPoster &&
                                        <p className="text-gray-700 text-base mb-1"><b>Main-Event poster:</b> <a
                                            className="text-blue-600" href={event.mainEventPoster}>Click Here</a></p>}
                                    <div className="flex items-center space-x-4 text-gray-500">
                                        <div className="flex items-center">
                                            <svg className="w-4 h-4 text-gray-500" xmlns="http://www.w3.org/2000/svg"
                                                 fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round"
                                                      d="M12 8v4l3 2M12 8l-3 2M12 8l-3 2M12 8l3 2"/>
                                            </svg>
                                            <p className="ml-2 text-sm">{event.location}</p>
                                        </div>
                                        <div className="flex items-center">
                                            <svg className="w-4 h-4 text-gray-500" xmlns="http://www.w3.org/2000/svg"
                                                 fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round"
                                                      d="M12 6v6m0 0L9 9m3 3l3-3"/>
                                            </svg>
                                            <p className="ml-2 text-sm">{event.dateTime}</p>
                                        </div>
                                    </div>
                                    <div className="mt-4 w-full">
                                        <a href={event.eventLink} target="_blank"
                                           className="w-full py-2 px-4 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition duration-300">
                                            Learn More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>


            </div>
            <Footer/>
        </div>
    );
};

export default NewsEvents;
